module.exports = __webpack_public_path__ + "static/img/verifyMoaIsInstall_pic01.cb3d8d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/verifyMoaIsInstall/verifyMoaIsInstall_pic01.png
// module id = 597
// module chunks = 1